module.exports = __webpack_public_path__ + "static/img/pic25.3bc6cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic25.png
// module id = FRgm
// module chunks = 0